<template>
<div id="filtersWrapper">
    <h3 v-show="is_mobile()">הצג רק: </h3>
    <ul class="menu">
        <!-- <li v-for="item in menu" :key="item"><router-link :to="item.link" v-text="item.name"></router-link></li> -->
        
            <li class="menuLink" v-for="menuItem in menuList" v-show="!(is_mobile() && !menuItem.mobile)" :key="menuItem.name"><a :class="(menuItem.is_active ? 'active' : '')" v-text="menuItem.name" @click="menuItem.click(menuItem)"></a></li>
        
 
        <div v-if="is_mobile()" class="clr"></div>
        
        <li v-if="is_mobile()">
            <h3>סנן לפי סגנון</h3>
            <div id="genres" class="noselect">
                <a :class="{active: this.isGenreActive(genre.id)}" v-for="genre in $store.genres" v-text="genre.name" :key="genre.id" @click="changeGenres(genre.id)"></a>
            </div>
        </li>

        <li id="dateWrapper">
          <h3 v-if="is_mobile()">חיפוש בין תאריכים:</h3>
          <VueDatePicker v-model="dateVal" auto-apply format="yyyy/MM/dd" range  week-start="0" placeholder="לפי תאריך" :max-date="new Date()" :day-names="['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז']"  locale="he" cancelText="ביטול" selectText="בחר" :rtl="true" ></VueDatePicker>
        </li>

        <li>
          <div class="search_input">
            <h3 v-if="is_mobile()">חיפוש חופשי:</h3>
            <div class="inp" style="position: relative; display:inline-block;"><span class="search_ico"><i class="fas fa-search"></i></span> <input type="text" @change="searcPropsLocal.q = $event.target.value" @keyup="searcPropsLocal.q = $event.target.value" placeholder="חפש שיר/אמן"></div>
          </div>
        </li>

    </ul>
</div>
</template>



<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  components: { VueDatePicker },
  props: ["searcProps"],
  data(){

    let today = new Date()
    today.setHours(0, 0, 0, 0)

    let yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)
    yesterday.setHours(0, 0, 0, 0);

    var self = this;

    return {
      searcPropsLocal: this.searcProps,
      menuList: [
        {name: 'קטלוג', mobile:false, is_active: true, click(item){ 
          self.resetProps();
          for(let i in self.menuList) { self.menuList[i].is_active = false; } item.is_active=true; 
          // self.searcPropsLocal.mixed_results = true;
        }},
        {name: 'סגנון מוזיקלי', mobile:false, is_active: false, click(item){ 
          self.resetProps();
          for(let i in self.menuList) { self.menuList[i].is_active = false; } item.is_active=true;
          self.searcPropsLocal.genres_show=!self.searcPropsLocal.genres_show; 
        }},
        {name: 'סינגלים', mobile:true, is_active: false, click(item){ 
          self.resetProps();
          for(let i in self.menuList) { self.menuList[i].is_active = false; } item.is_active=true;
          self.searcPropsLocal.is_album = false 
        }},
        {name: 'אלבומים', mobile:true, is_active: false, click(item){ 
          self.resetProps();
          for(let i in self.menuList) { self.menuList[i].is_active = false; } item.is_active=true;
          self.searcPropsLocal.is_album = true 
        }},
        {name: 'קליפים', mobile:true, is_active: false, click(item){ 
          self.resetProps();
          for(let i in self.menuList) { self.menuList[i].is_active = false; } item.is_active=true;
          self.searcPropsLocal.type = 9 
        }},

      ],
      dateVal: {
        startDate: null,
        endDate: null
      },
      show_user_popup: false,

      locale: {
        direction: 'rtl', //direction of text
        format: 'DD/MM/YYYY', //fomart of the dates displayed
        separator: ' - ', //separator between the two ranges
        applyLabel: 'חפש',
        cancelLabel: 'ביטול',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        firstDay: 0 //ISO first day of week - see moment documenations for details
      },
      ranges: {
          'היום': [today, today],
          'אתמול': [yesterday, yesterday],
        // 'This month': [thisMonthStart, thisMonthEnd],
          'השנה': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
          'החודש האחרון': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
      }
    }
  },
  methods: {
    resetProps(){
      
      this.searcPropsLocal.genres = [];
      this.searcPropsLocal.genres_show = false;
      this.searcPropsLocal.is_album = false;
      this.searcPropsLocal.date_from = null;
      this.searcPropsLocal.date_to = null;
      this.searcPropsLocal.q = '';
      this.searcPropsLocal.type = ''

    },
    isGenreActive(genreId){
      const ret = this.searcPropsLocal.genres.some((item)=>item == genreId);
      return ret
    },
    changeGenres(genreId){
      let newGenres = this.pushOrPull(this.searcPropsLocal.genres, genreId);
      this.searcPropsLocal.genres = newGenres;
      console.log(this.searcPropsLocal.genres);
    }
  },
  watch:{
    dateVal(){
      this.searcPropsLocal.date_from = this.dateVal[0];
      this.searcPropsLocal.date_to = this.dateVal[1];
    }
  }
}
</script>

<style lang="scss" >
#filtersWrapper { 
    .vue-daterange-picker { margin:0 25px; }

    .search_input {
        & { position: relative; margin-right: 25px; }
        .search_ico { position: absolute; left: 10px; top:3px; opacity: 0.6; }
        input { background:#fff; color:rgb(73, 80, 87); height: 32px;   border: solid 0.8px #333333; border-radius: 36px; padding:0 15px 0 40px;
            &:focus {
            border-color: #4dabf7;
            outline: none;
            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1), 0 0 8px rgba(34, 139, 230, 0.5);
            }
        }
    }
}

@media only screen and (max-width: 600px) { 
    #filtersWrapper {  
        &{ padding: 25px; overflow-y: auto; margin-bottom: 50px; }

        h3{ margin-bottom: 10px;}

        .menu {
            li.menuLink { float: right; margin-left: 10px; margin-bottom: 10px;
                a { display: block; padding:8px 15px; border:1px solid #eee; border-radius: 10px; color: #333333; 
                    &.active { border-color:#000;}
                }
            }
        }
        #dateWrapper { margin-top: 30px; }
        .vue-daterange-picker, .search_input { margin:0px 0px 30px 0px;}

        #genres a { height: 35px; line-height: 35px; padding: 0 8px; margin-left:8px; margin-bottom: 8px;}
    }
    .md-dialog-actions { position: fixed !important; bottom: 0px !important; background:#eee; left: 0px; right: 0px; text-align: center; display: block !important; padding: 7px 0 !important;
        button { background:#0077ff; color: #fff !important; font-size: 20px; font-weight: bold; border-radius: 20px; height: 36px; line-height: 36px; padding: 0 15px;}
    }

}
</style>